// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FilterTag_wrapper__octlm","closeButton":"FilterTag_closeButton__OOow9","bodyFilterTag":"FilterTag_bodyFilterTag__qo3DX"};